import Banner from '@components/Banner/banner';
import Footer from '@components/Footer/Footer';
import ContactOne from './sections/ContactOne';
import { useTranslation } from 'react-i18next';

function Contact() {
  const { t } = useTranslation('contact');
  return (
    <>
      <Banner title={t('contact.title')} />
      <ContactOne />
      <Footer />
    </>
  );
}

export default Contact;
